import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment.js';
import { trackTikTokEvent, trackPostHog } from '../utils/tracking.js';

export const trackPauseGame = (gameId) => {
  const eventData = {
    game_id: gameId,
    ...getEnvironmentData()
  };

  track('pause_game', eventData);
  
  trackTikTokEvent('ViewContent', {
    content_name: 'game_pause',
    content_type: 'product',
    content_id: gameId
  });

  trackPostHog('game_paused', eventData);
};

export const trackGoalScored = (scorerName, minute, gameId, isOwnGoal = false) => {
  const eventData = {
    scorer: scorerName,
    minute: minute,
    game_id: gameId,
    is_own_goal: isOwnGoal,
    ...getEnvironmentData()
  };

  track('goal_scored', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'goal_scored',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('AddToCart', tiktokEvent);

  trackPostHog('goal_scored', eventData);
};

export const trackGoalRemoved = (scorerName, minute, gameId) => {
  const eventData = {
    scorer: scorerName,
    minute: minute,
    game_id: gameId,
    ...getEnvironmentData()
  };

  track('goal_removed', eventData);
  
  const tiktokEvent = {
    contents: [
      {
        content_name: 'goal_removed',
        content_type: 'product',
        content_id: gameId
      }
    ]
  };
  trackTikTokEvent('RemoveFromCart', tiktokEvent);

  trackPostHog('goal_removed', eventData);
}; 